/**
 * The monthly free allowance, and the one question every balance raises
 * against it: is this number the allowance itself, or a larger balance
 * sitting on top of it?
 *
 * It matters because the server RAISES a free account to the allowance and
 * never adds to it (`backend/app/services/free_credits.py`). Below the line
 * the monthly story is the whole truth — 2 now, 3 again on the 1st. At or
 * above it nothing happens on the 1st at all: someone who cancelled a
 * subscription goes on holding what they bought, and there the monthly
 * wording stops describing anything and starts promising. "242 left · back
 * to 3 on 1 October" reads as an announcement that 239 transcriptions are
 * about to be taken away — a threat, made by the card of the tier they are
 * actually on, about something that will not happen.
 *
 * Mirrors the backend's FREE_MONTHLY_CREDITS. The number is also written
 * into the copy ("3 again every month"), like every plan number on the
 * pricing page, so changing it means editing the catalogs too.
 */
export const FREE_MONTHLY_CREDITS = 3

/**
 * Whether the monthly wording — "left this month", "back to 3 on the 1st" —
 * describes this balance truthfully.
 *
 * At exactly the allowance it still does, and the boundary is deliberately
 * inclusive: nothing is taken on the 1st, the top-up raises to the same
 * number, and a brand-new account reading "3 left this month · back to 3 on
 * 1 October" is being told the actual shape of the tier. Above the line the
 * balance is neither monthly nor at risk, whatever it was bought as.
 */
export function balanceIsMonthly(credits: number): boolean {
  return credits <= FREE_MONTHLY_CREDITS
}
